import { useHeaderDashboardContext } from '../context/HeaderDashboard.context';

export const useHeaderDashboard = () => {
  return useHeaderDashboardContext();
};
